import { c as _c } from "react/compiler-runtime";
import { UserAvatarWithMenu } from "@components/user-more-info-menu/user-avatar-with-menu";

/** Member assigned to a markup */

/** Avatar of the assignee of a markup in the board, with their card on hover */
export function MarkupsBoardAvatar(t0) {
  const $ = _c(2);
  const {
    assignee
  } = t0;
  let t1;
  if ($[0] !== assignee) {
    t1 = <UserAvatarWithMenu member={assignee} size="x-small" />;
    $[0] = assignee;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}